import { useAppContext } from '../../appProvider/contextProvider';
import { getServiceWorker, getWebSiteSnippet, verifyIntegration} from '../../services/websitesService';
import  { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import { useState } from 'react';
import WordpressIcon from '../../assets/images/wordpress.svg';
import WooCommIcon from '../../assets/images/woocommerce-logo.svg';
import WordPressPrompt from '../../components/PluginPrompts/WordpressPrompt';
import HelperComponent from '../../components/HelperComponent/HelperComponent';
import { ERRORS } from '../../constants/AppConstants';


const Integration = () => {

    const { selectedWebsite, setIsBgDisabled} = useAppContext();

    const [snippet, setSnippet] = useState('');

    const [selectedTab, setSelectedTab] = useState('manual');
   
    const [openWordpressPrompt, setOpenWordpressPrompt] = useState(false);
    const [isWooPromptOpen, setWooPromptOpen] = useState(false);

    useQuery(['fetchWebsiteSnippet', selectedWebsite?.id], 
        () => getWebSiteSnippet(selectedWebsite?.id),
        {
            enabled: !!selectedWebsite,
            onSuccess: ({code}) => {
                if(code) {
                    setSnippet(code)
                } else {
                    toast.error('Something went wrong, Try again later');
                }
            }
        }
    )

    const downloadSW = useMutation((event) => {
        event.preventDefault();
        return getServiceWorker(selectedWebsite?.id);
    }, {
        onSuccess: (data) => {
            saveAs(data, 'sw-cw.js');
        }
    });

    const copyText = (snippet) => {
        const codeBlock = snippet; 
        /* Copy the text inside the text field */
        navigator.clipboard.writeText(codeBlock);
        toast.success('Code Copied');
    }

    const verify = useMutation((event) => {
        event.preventDefault();
        return verifyIntegration(`${selectedWebsite.url}sw-cw.js`);
    }, {
        onSuccess: ((verifyDetails) => {
            if(verifyDetails.errors ) {
                if(verifyDetails.errors.error) toast.error(verifyDetails.errors.error)
                if(verifyDetails.errors.sw_path) toast.error(ERRORS.sw_path)
            } else {
                toast.success(verifyDetails.detail);
            }
        }),
        onError: ((error) => {
            console.log(error);
        })
    });

    const onOpenWordpressPrompt = (isWoo) => {
        setOpenWordpressPrompt(true);
        setIsBgDisabled(true);
        setWooPromptOpen(isWoo);
    }
    const onCloseWordpressPrompt = () => {
        setOpenWordpressPrompt(false);
        setIsBgDisabled(false);
        setWooPromptOpen(false);
    }

    return <>
        <div className="panel full-height">
                <div className="panel-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">
                            Getting Started
                            <HelperComponent
                                component={'Getting Started (How to install)'}  
                                href="https://chirpyweb.com/documentation_posts/how-to-install/" />
                        {/* <small className="text-grey thin">Please select the correct website from the dropdown list if you have numerous websites.</small> */}
                        </h3>
                    </div>                                
                </div>
                <div className="panel-body scrollable_y">
                    <div className="tab-container">
                        <div className="tabs-header align-items-center justify-content-between px-3">
                            <div className="tabs-list align-self-end mt-2">
                                {/* <a href="">Plugin Install</a> */}
                                <a className={`${selectedTab === 'manual' && 'active'}`} 
                                    onClick={() => setSelectedTab('manual')}
                                >Manual Install</a>
                                <a className={`${selectedTab === 'plugin' && 'active'}`} 
                                    onClick={() => setSelectedTab('plugin')}
                                >Plugin Install</a>
                                <a className={`${selectedTab === 'key' && 'active'}`} 
                                    onClick={() => setSelectedTab('key')}
                                >Website Key</a>
                            </div>

                        </div>
                        {
                            selectedTab === 'manual' && <div className="tab-content my-3">
                                    <div className="panel">
                                        <div className="panel-header m-0">
                                            <h3 className="text-dark text-center mb-0">Manual Install (Javascript Website)</h3>
                                        </div>
                                        <div className="panel-body p-0">
                                            <div className="d-flex flex-wrap align-items-stretch installation-wrapper">
                                                <div className="col-12 col-md-6 col-xl-4 text-center">
                                                    <div className="py-4">
                                                        <h5 className="text-dark medium mb-3">Step 1 - Insert Code</h5>
                                                        <p className="text-light mb-3"><small>{`To install ChirpWeb on ${selectedWebsite?.title || selectedWebsite?.url}, regardless of the back-end or platform, please paste the following code before the </head> tag.`}</small></p>
                                                        <div className="box d-flex justify-content-between align-items-center">
                                                            <p id={'code'} className="text-dark regular" style={{overflowWrap: 'anywhere'}} >
                                                                {snippet}
                                                            </p>
                                                            <button className="btn btn-neutral mt-2" onClick={() => copyText(snippet)} ><i className="icon icon-copy"></i></button>
                                                        </div>
                                                    </div>                                                    
                                                </div>
                                                <div className="col-12 col-md-6 col-xl-4">
                                                    <div className="py-4 text-center">
                                                        <h5 className="text-dark medium">Step 2 - Download File</h5>
                                                        <p className="text-light mb-3"><small>Please download the following file and place it in the root directory of your website. 
                                                            A domain’s document root, also known as the home folder, is the main folder that contains all of the files for either a domain or a subdomain.</small></p>
                                                        <div className="text-center my-4">
                                                            <button className="btn btn-primary" onClick={downloadSW.mutate} >Download the File</button>
                                                        </div>
                                                    </div> 
                                                </div>
                                                <div className="col-12 col-md-6 col-xl-4">
                                                    <div className="py-4 text-center">
                                                        <h5 className="text-dark medium">Step 3 - Verify Installation</h5>
                                                        <p className="text-light">
                                                            <small>Click on "Verify Installation" below to make sure that everything is set up correctly.</small>
                                                        </p>
                                                        <div className="text-center my-4">
                                                            <button className="btn btn-primary" onClick={verify.mutate} >Verify Installation</button>
                                                        </div>                                                        
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                        {
                            selectedTab === 'plugin' && <div className="tab-content my-3">
                                <div className="row">
                                    <div className="col-12 col-md-6 col-lg-4 mb-3">
                                        <div className="panel full-height plugin-wrapper">
                                            <div className="panel-header">
                                                <h5 className="text-center medium">ChirpyWeb WordPress Plugin</h5>
                                            </div>
                                            <div className="panel-body text-center">
                                                <img src={WordpressIcon} className="img-md" alt="Wordpress"/>
                                                {/* <p className="my-4 text-grey thin">While the plain HTML code works on any website, the ChirpWeb plugin for WordPress unlocks 
                                                    additional functionalities.</p> */}
                                                    <p></p>
                                                <button 
                                                    className="btn btn-primary mt-4" 
                                                    onClick={() =>onOpenWordpressPrompt(false)}
                                                > Installation Guide</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4 mb-3">
                                        <div className="panel full-height plugin-wrapper">
                                            <div className="panel-header">
                                                <h5 className="text-center medium">ChirpyWeb WooCommerce Plugin</h5>
                                            </div>
                                            <div className="panel-body text-center">
                                                <img src={WooCommIcon} className="img-md" alt="Wordpress"/>
                                                <p></p>
                                                <button 
                                                    className="btn btn-primary mt-4" 
                                                    onClick={() =>onOpenWordpressPrompt(true)}
                                                > Installation Guide</button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-12 col-md-6 col-lg-4 mb-3 ">
                                        <div className="panel full-height plugin-wrapper">
                                            <div className="panel-header">
                                                <h5 className="text-center medium">Activation Code for the Bubble.io plugin</h5>
                                            </div>
                                            <div className="panel-body full-height p-2 text-center">
                                                <div className="d-flex full-height justify-content-center align-items-center">
                                                    <img src="images/account_key.svg" alt="Wordpress"/>                                                        
                                                </div> 
                                            </div>
                                            <div className="panel-footer m-2">
                                                <div className="box d-flex justify-content-between align-items-center">
                                                    <p>TJ3ACS27B4R1K8QF5</p>
                                                    <button className="btn btn-neutral"><i className="icon icon-copy"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4 mb-3 ">
                                        <div className="panel full-height plugin-wrapper">
                                            <div className="panel-header">
                                                <h5 className="text-center medium">Installation Code for Wix</h5>
                                            </div>
                                            <div className="panel-body full-height p-2 text-center">
                                                <div className="d-flex flex-column full-height">
                                                    <img src="images/wix.svg" alt="Wordpress" className="my-2 img-sm"/>  
                                                    <p className="my-4 text-grey thin">Please insert the following code before the /head> 
                                                        element to install Push Monkey on Wix, Instapage, or Bubble.io, independent of the back-end or platform.</p>                                                        
                                                </div>                                                                                                       
                                            </div>
                                            <div className="panel-footer m-2">
                                                <div className="box d-flex justify-content-between align-items-center">
                                                    <code>
                                                        <link id="pm-manifest" rel="manifest" href="https://getpushmonkey.com/manifest-TJ3ACS27B4R1K8QF5.json" />
                                                        <script type="text/javascript" id="pm-sdk" src="https://getpushmonkey.com/sdk/config-TJ3ACS27B4R1K8QF5.js?not_wp=1"></script>
                                                    </code>
                                                    <button className="btn btn-neutral"><i className="icon icon-copy"></i></button>
                                                </div>
                                            </div>  
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4 mb-3">
                                        <div className="panel full-height plugin-wrapper">
                                            <div className="panel-header">
                                                <h5 className="text-center medium">On Shopify</h5>
                                            </div>
                                            <div className="panel-body text-center">
                                                <img src="images/shopify1.svg" className="img-sm" alt="Wordpress"/>
                                                <p className="my-4 text-grey thin">While the standard HTML code works on any website, the Push Monkey app for 
                                                    Shopify unlocks additional 
                                                    capabilities like Abandoned Cart Notifications.</p>
                                                <button className="btn btn-primary">Install the app <i className="ml-1 icon icon-edit-inline"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4 mb-3">
                                        <div className="panel full-height plugin-wrapper">
                                            <div className="panel-header">
                                                <h5 className="text-center medium">On WooCommerce</h5>
                                            </div>
                                            <div className="panel-body text-center">
                                                <img src="images/woocommerce.svg" className="img-sm" alt="Wordpress"/>
                                                <p className="my-4 text-grey thin">While the plain HTML code can be used on any website, 
                                                    the Push Monkey plugin for WooCommerce unlocks additional capabilities such as Abandoned Cart Notifications.</p>
                                                <button className="btn btn-primary">Install the plugin <i className="ml-1 icon icon-edit-inline"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-4 mb-3">
                                        <div className="panel full-height plugin-wrapper">
                                            <div className="panel-header">
                                                <h5 className="text-center medium">Installation Code for Instapage</h5>
                                            </div>
                                            <div className="panel-body text-center">
                                                <img src="images/instapage.svg" alt="Wordpress"/>
                                                <p className="my-4 text-grey thin">Please insert the following code before the /head> 
                                                    element to install Push Monkey on Wix, Instapage, or Bubble.io, 
                                                    independent of the back-end or platform.</p>
                                            </div>
                                            <div className="panel-footer m-2">
                                                <div className="box d-flex justify-content-between">
                                                    <code>
                                                        <link id="pm-manifest" rel="manifest" href="https://getpushmonkey.com/manifest-TJ3ACS27B4R1K8QF5.json" />
                                                        <script type="text/javascript" id="pm-sdk" src="https://getpushmonkey.com/sdk/config-TJ3ACS27B4R1K8QF5.js?not_wp=1"></script>
                                                    </code> 
                                                    <button className="btn btn-neutral"><i className="icon icon-copy"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        }
                        {
                            selectedTab === 'key' && <div className="tab-content my-3">
                                <div className="row">
                                    {/* <label>Website Id</label> */}
                                    <div className="col-lg-4 mb-3">
                                        <div className="panel full-height plugin-wrapper">
                                            <div className="panel-header">
                                                <h5 className="text-center medium">Website Id</h5>
                                            </div>
                                            <div className="panel-body text-center">
                                                <div className="box d-flex justify-content-between align-items-center">
                                                    <p id={'code'} className="text-dark regular" style={{overflowWrap: 'anywhere'}} >
                                                        {selectedWebsite?.website_key}
                                                    </p>
                                                    <button className="btn btn-neutral mt-2" onClick={() => copyText(selectedWebsite?.website_key)} ><i className="icon icon-copy"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>

            {
                openWordpressPrompt && <WordPressPrompt onClose={onCloseWordpressPrompt} isWoo={isWooPromptOpen} />
            }
    </>
}

export default Integration;